module.exports = __webpack_public_path__ + "static/media/rumasuar_kutipan.f0eef89d.jpg";